export const getPageRangeNumbers = (
  currentPageNumber: number,
  totalPages: number
): Array<number | 'ellipsis'> => {
  const pages: Array<number | 'ellipsis'> = []

  const addRangeNumber = (start: number, end: number) => {
    for (let i = start; i <= end; i++) {
      pages.push(i)
    }
  }

  if (totalPages <= 7) {
    addRangeNumber(1, totalPages)
    return pages
  }

  // Always show first page
  pages.push(1)

  // Left ellipsis or range
  if (currentPageNumber > 4) {
    pages.push('ellipsis')
  } else {
    addRangeNumber(2, 5)
  }

  // Middle pages around current
  if (currentPageNumber > 4 && currentPageNumber < totalPages - 3) {
    addRangeNumber(currentPageNumber - 1, currentPageNumber + 1)
  }

  // Right ellipsis or range
  if (currentPageNumber < totalPages - 3) {
    pages.push('ellipsis')
  } else {
    addRangeNumber(totalPages - 4, totalPages - 1)
  }

  // Always show last page
  pages.push(totalPages)

  return pages
}
